















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Avatar from 'vue-avatar';
import { UserProfile } from '../../models/userdata/profile';
import { vxm } from '@/store.vuex';
@Component({
  components: {
    Avatar,
  },
})
export default class ProfilePictureEdit extends Vue {
  $wlToastr: any;
  private showAvatar: boolean = true;
  private uploadProfileFileUrl: string = '';
  private userProfile: UserProfile = new UserProfile();
  private showSaveAndEditOption: boolean = false;
  @Prop({ default: () => new Vue(), type: Vue }) bus;
  @Prop() isFinished;
  @Prop () isRequiredStep;
  @Prop () minimumEntries;
  @Watch('showAvatar')
  addressChange(newVal, oldVal) {
    const disable = this.minimumEntries >= 0 ? (this.isRequiredStep ? this.showAvatar : this.isRequiredStep) : this.showAvatar;
    this.$emit('disable-next-button', disable);
  }
  mounted() {
    this.bus.$on('on-next-step', this.saveUserProfilePic);
    this.setProfilePicture();
  }

  beforeDestroy() {
    this.bus.$off('on-next-step');
  }

  get FullName() {
    return (
      vxm.users.myUserProfile.firstName + ' ' + vxm.users.myUserProfile.lastName
    );
  }
  setProfilePicture() {
    this.uploadProfileFileUrl =
      vxm.users.myUserProfile.userProfileBasePath +
      vxm.users.myUserProfile.profilePicGUID +
      '.' +
      vxm.users.myUserProfile.profilePicExtType;

    let response = false;
    if (vxm.users.myUserProfile.profilePicGUID == null) {
      response = true;
    } else if (!this.uploadProfileFileUrl) {
      response = true;
    }
    this.showAvatar = response;
  }
  onFileChange(e) {
    let vm = this;
    const file = e.target.files[0];
    vm.uploadProfileFileUrl = URL.createObjectURL(file);
    vm.userProfile.profilePictureFile = file;
    vm.showSaveAndEditOption = true;
    if (vm.uploadProfileFileUrl) {
      vm.showAvatar = false;
    }
    this.$modal.hide('upload-profile-pic-modal');
  }
  saveUserProfilePic() {
    let vm = this;
    if (
      !this.userProfile.profilePictureFile &&
      vxm.users.myUserProfile.profilePicGUID
    ) {
      this.$emit('go-to-next');
      this.$emit('update-next-text', 'Find Jobs');
      return;
    }
    if (vm.validateUserProfilePicFileFormat()) {
      return;
    }
    if (vm.userProfile.profilePictureFile.size >= 10485760) { 
      //10485760 , 2097152
      console.log(
        'file size - ' + vm.userProfile.profilePictureFile.size + ' in bytes',
      );
      vm.$wlToastr('error', 'File size cannot exceed 10 mb', 'Profile Picture');
      return;
    }
    const respPromise: any = vxm.users.saveProfilePicture(vm.userProfile);
    Promise.all([respPromise]).then((values) => {
      if (values[0]) {
        if (values[0].success) {
          const resp: any = vxm.users.refreshProfileInfo();
          Promise.all([resp]).then((values) => {
            if (values[0]) {
              vm.showSaveAndEditOption = false;
              vm.setProfilePicture();
              vm.userProfile.profilePictureFile = null;
              vm.$wlToastr(
                'success',
                'Profie Picture Uploaded Successfully!',
                'Profile Picture',
              );
              this.$emit('go-to-next');
              this.$emit('update-next-text', 'Find Jobs');
            }
          });
        } else {
          vm.$wlToastr('error', values[0].errorMessage, 'Profile Picture');
        }
      }
    }).catch((e) => {
        if (e && e.response && (e.response.status === 503 || e.response.status === 418)) {
          this.$wlToastr(
            'error',
            this.$t('ResumeDetails_SecurityRisk'),
          );
        }
      });
  }
  validateUserProfilePicFileFormat() {
    let vm = this;
    let response = false;
    console.log('userProfile ', vm.userProfile);
    const ext = vm.userProfile.profilePictureFile.name.match(/\.([^\.]+)$/)[1];
    const fileNameFormat = vm.userProfile.profilePictureFile.name.match(
      /\.([^\.]+)$/,
    )[0];
    switch (ext && ext.toLowerCase()) {
      case 'png':
      case 'jpeg':
      case 'jpg':
        break;
      default:
        console.log('Not allowed');
        response = true;
        vm.$wlToastr(
          'error',
          fileNameFormat +
            ' is an unsupported file format. Following file formats are allowed: .png, .jpeg',
          'Profile Picture',
        );
    }
    return response;
  }
}
